<template>
  <ol class="Breadcrumb breadcrumb">
    <li v-for="(link, index) in links" :key="index" :class="`breadcrumb-item${link.active ? ' active' : ''}`"><router-link v-if="link.path" :to="{ path: `/${link.path}` }">{{ link.name }}</router-link><span v-else>{{ link.name }}</span></li>
  </ol>
</template>

<script>
export default {
  name: 'Breadcrumb',
  components: {},
  props: {
    links: Array
  },
  mounted () {},
  data: () => ({})
}
</script>

<style lang="scss">
    .Breadcrumb {
      border-radius: 0;
      border-bottom: 1px solid #DDD;
    }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/breadcrumb.vue